import { render, staticRenderFns } from "./px-icon.vue?vue&type=template&id=59f662f8&scoped=true&"
import script from "./px-icon.vue?vue&type=script&lang=ts&"
export * from "./px-icon.vue?vue&type=script&lang=ts&"
import style0 from "./px-icon.vue?vue&type=style&index=0&id=59f662f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f662f8",
  null
  
)

export default component.exports